import { React, useEffect, useState, useContext } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import {
  EnhancedAutocomplete,
  ResearchPositionCreate,
  ResearchPositionTable,
  ResearchPositionOverview,
} from "..";
import { UserContext } from "../../App";
import { FormGroup, FormControlLabel, Switch } from "@mui/material";
import "@geoapify/geocoder-autocomplete/styles/minimal.css";
import "../../styles/ResearchPositionSearch.css";

function ResearchPositionSearch() {
  const { userType, username } = useContext(UserContext);

  const [draft, setDraft] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const [showUnapplied, setShowUnapplied] = useState(false);
  const [favorite, setFavorite] = useState(false);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState([]);

  const [researchPositionCompensation, setResearchPositionCompensation] = useState([]);
  const [researchPositionJobType, setResearchPositionJobType] = useState([]);
  const [researchPositionResearchArea, setResearchPositionResearchArea] = useState([]);

  const [skills, setSkills] = useState([]);
  const [facultyNames, setFacultyNames] = useState([]);

  const [researchPositions, setResearchPositions] = useState([]);
  const [selectedResearchPosition, setSelectedResearchPosition] = useState({});

  const [availableFaculties, setAvailableFaculties] = useState([]);
  const [availableSkills, setAvailableSkills] = useState([]);
  const [availableCompensations, setAvailableCompensations] = useState([]);
  const [availableLocations, setAvailableLocations] = useState([]);
  const [availableJobTypes, setAvailableJobTypes] = useState([]);
  const [availableResearchAreas, setAvailableResearchAreas] = useState([]);

  const [updateFavorites, setUpdateFavorites] = useState(false);
  const [updateOffset, setUpdateOffset] = useState(false);
  const [updateApply, setUpdateApply] = useState(false);

  const [updateTable, setUpdateTableHook] = useState(false);
  const [editedTable, setEditedTable] = useState(false);

  const [loadingJobFromURL, setLoadingJobFromURL] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [positionOffset, setPositionOffset] = useState(0);
  const [handleChange, setHandleChange] = useState(false);

  const itemsPerPage = 5;


  const setUpdateTable = (value) => {
    setUpdateTableHook(value);
    setSelectedResearchPosition({});
  };

  const handleSelectedResearchPosition = (researchPosition) => {
    if (userType === "student") {
      const body = new FormData();
      body.append("positionId", researchPosition.positionId);
      axios.post("/faculty/incrementViews", body).then((res) => {
      });
    }

    setSelectedResearchPosition(researchPosition);
  };

  const handleAppliedResearchPosition = (researchPosition) => {
    if (userType === "student") {
      const body = new FormData();
      body.append("positionId", researchPosition.positionId);
      axios.post("/faculty/incrementApplications", body).then((res) => {
      });
    }
  };


  const showSearchResults = () => {
    const body = new FormData();
    body.append("pid", username);
    body.append("title", title);
    body.append("location", location || "");
    body.append("researchPositionCompensation", researchPositionCompensation);
    body.append("skills", skills);
    body.append("researchPositionJobType", researchPositionJobType);
    body.append("researchPositionResearchArea", researchPositionResearchArea);
    body.append("userType", userType);
    body.append(
      "facultyNames",
      userType === "faculty" ? [username] : facultyNames,
    );
    body.append("draft", draft);
    body.append("active", showInactive == false);
    body.append("applied", showUnapplied == false);
    body.append("favorite", favorite);

    axios.post("/faculty/searchResearchPositions", body).then((res) => {
      const data = res.data;
      if (data.success) {

        setResearchPositions(data.researchPositions);

        const queryParams = new URLSearchParams(window.location.search);
        const jobId = queryParams.get("jid"); // Ensure the parameter name is correct
        if (jobId) {
          const job = data.researchPositions.find(job => job.positionId.toString() === jobId);
          if (job) {
            // sets correct page number
            const index = data.researchPositions.findIndex(job => job.positionId.toString() === jobId);
            const newPage = Math.floor(index / itemsPerPage);
            setCurrentPage(newPage);
            setItemOffset(newPage * itemsPerPage);

            setSelectedResearchPosition(job);
            setLoadingJobFromURL(true);

          } else {
          }
        } else {
          if (positionOffset == 0) {
            setSelectedResearchPosition(data.researchPositions[0]);
          }
          else {
            setSelectedResearchPosition(data.researchPositions.filter(pos => pos.positionId == positionOffset)[0]);
          }

        }


      }
    });
  };

  // Update URL after job is loaded
  useEffect(() => {
    if (loadingJobFromURL) {
      const newUrl = window.location.pathname;
      window.history.pushState(null, "", newUrl);
    }
  }, [loadingJobFromURL]);

  // To only update the research position, not unselecting research position and not going back to page 1
  useEffect(() => {

    if (!handleChange) {
      setPositionOffset(0);
      setCurrentPage(0);
    }
    else {
      setPositionOffset(0);
    }
    showSearchResults();

    // Check if the dependencies that require toggling `updateOffset` have changed
    if (title || location || researchPositionCompensation || researchPositionJobType ||
      researchPositionResearchArea || skills || facultyNames || draft ||
      showInactive || showUnapplied || favorite || updateTable) {
      setUpdateOffset(prev => !prev);
    }
  }, [
    updateFavorites, editedTable, updateApply, // these were in the first useEffect
    title, location, researchPositionCompensation, researchPositionJobType, // these and below were in the second useEffect
    researchPositionResearchArea, skills, facultyNames, draft,
    showInactive, showUnapplied, favorite, updateTable
  ]);


  useEffect(() => {
    if (userType !== "faculty") {
      axios.get("/faculty/faculties").then((res) => {
        const data = res.data;
        if (data.success) {
          setAvailableFaculties(data.faculties);
        } else {
          return setAvailableFaculties([]);
        }
      });
    }
  }, [updateTable]);

  useEffect(() => {
    axios.get("/faculty/locations").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableLocations(data.locations);
      } else {
        return setAvailableLocations([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/skills").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableSkills(data.skills);
      } else {
        return setAvailableSkills([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/compensations").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableCompensations(data.compensations);
      } else {
        return setAvailableCompensations([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/jobTypes").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableJobTypes(data.jobTypes);
      } else {
        return setAvailableJobTypes([]);
      }
    });
  }, []);

  useEffect(() => {
    axios.get("/faculty/researchAreas").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableResearchAreas(data.researchAreas);
      } else {
        return setAvailableResearchAreas([]);
      }
    });
  }, []);

  const resetHooks = () => {
    setTitle("");
    setLocation([]);
    if (userType === "faculty") {
      setFacultyNames([username]);
    } else {
      setFacultyNames([]);
    }
    setResearchPositionCompensation([]);
    setResearchPositionJobType([]);
    setResearchPositionResearchArea([]);
    setSkills([]);
    setDraft(false);
    setFavorite(false);
    setShowInactive(false);
    setShowUnapplied(false);
    setLoadingJobFromURL(false);
  };

  return (
    <div className="ResearchPositionSearch bg-brand-tertiary">
      <div className="ResearchPositionSearch-container flex flex-col p-8 ">
        <div className="ResearchPositionSearch-topContainer flex flex-wrap">
          <div className="ResearchPositionSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <EnhancedAutocomplete
            label="Location"
            placeholder="Location"
            options={availableLocations}
            selectedValue={location}
            selectedSetter={setLocation}
            isMultiSelect={false}
          />
          <EnhancedAutocomplete
            label="Compensation"
            placeholder="Compensation"
            options={availableCompensations}
            selectedValue={researchPositionCompensation}
            selectedSetter={setResearchPositionCompensation}
            isMultiSelect={true}
          />
          <EnhancedAutocomplete
            label="Position Types"
            placeholder="Position Types"
            options={availableJobTypes}
            selectedValue={researchPositionJobType}
            selectedSetter={setResearchPositionJobType}
            isMultiSelect={true}
          />
          <EnhancedAutocomplete
            label="Research Areas"
            placeholder="Research Areas"
            options={availableResearchAreas}
            selectedValue={researchPositionResearchArea}
            selectedSetter={setResearchPositionResearchArea}
            isMultiSelect={true}
          />
          {(userType === "faculty") ? null : (
            <EnhancedAutocomplete
              label="Faculty"
              placeholder="Faculty"
              options={availableFaculties}
              selectedValue={facultyNames}
              selectedSetter={setFacultyNames}
              isMultiSelect={true}
            />
          )}
          <EnhancedAutocomplete
            label="Skills"
            placeholder="Skills"
            options={availableSkills}
            selectedValue={skills}
            selectedSetter={setSkills}
            isMultiSelect={true}
          />

          {userType === "student" && (
            <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={favorite} />}
                label="Favorites"
                onChange={(event, checked) => setFavorite(checked)}
                className="flex justify-center items-center mx-3"
              />
            </FormGroup>
          )}

          {userType === "student" && (
            <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={showUnapplied} />}
                label="Unapplied"
                onChange={(event, checked) => setShowUnapplied(checked)}
                className="flex justify-center items-center mx-3"
              />
            </FormGroup>
          )}

          {(userType === "admin" || userType === "faculty") && (
            <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={showInactive} />}
                label="Show Inactive Jobs"
                onChange={(event, checked) => setShowInactive(checked)}
                className="flex justify-center mx-4"
              />
            </FormGroup>
          )}

          {(userType === "admin" || userType === "faculty") && (
            <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={draft} />}
                label="Drafts"
                onChange={(event, checked) => setDraft(checked)}
                className="flex justify-center mx-4"
              />
            </FormGroup>
          )}
          {(userType === "faculty" || userType === "admin") &&
            <ResearchPositionCreate
              userType={userType}
              username={username}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
            />}
          <button
            type="button"
            className="search-button px-4 h-11 mb-4 text-center py-2 bg-blue"
            onClick={resetHooks}
          >
            Reset Search
          </button>
        </div>
        <div className="ResearchPositionSearch-bottomContainer flex h-full">
          <div className="ResearchPositionSearch-leftContainer">
            <ResearchPositionTable
              researchPositions={researchPositions}
              selectedResearchPosition={selectedResearchPosition}
              setResearchPosition={handleSelectedResearchPosition}
              userType={userType}
              pid={username}
              updateFavorites={updateFavorites}
              setUpdateFavorites={setUpdateFavorites}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
              updateOffset={updateOffset}
              editedTable={editedTable}
              setEditedTable={setEditedTable}

              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              itemOffset={itemOffset}
              setItemOffset={setItemOffset}
              setPositionOffset={setPositionOffset}
              handleChange={handleChange}
              setHandleChange={setHandleChange}

            />
          </div>
          <div className="ResearchPositionSearch-rightContainer">
            <div>
              <ResearchPositionOverview researchPosition={selectedResearchPosition} onResearchPositionApplied={handleAppliedResearchPosition} userType={userType} pid={username} updateApply={updateApply} setUpdateApply={setUpdateApply} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ResearchPositionSearch;